import * as React from 'react';
import ScoreIndicator from './ScoreIndicator';
import { ScoreNumbers } from './ResultsContainer';
import './Scores.css';

interface Props {
    company: ScoreNumbers;
    industryMedian: ScoreNumbers;
    industryNPS: ScoreNumbers;
}

class Scores extends React.Component<Props> {
    render() {
        const { company, industryMedian, industryNPS } = this.props;

        return (
            <div className="flex-item">
                <div className="flex-container">
                    <div className="flex-item">
                        <div className="score-labels">
                            <h3 className="score-label top-score-label">When it comes to analytics my company...</h3>
                            <h3 className="score-label">Your Response</h3>
                            <h3 className="score-label">Your Industry Median</h3>
                            <h3 className="score-label">Your Industry Satisfaction</h3>
                        </div>
                    </div>
                    <div className="flex-item">
                        <ScoreIndicator
                            label="Must Maintain \n an Advantage"
                            companyScore={company.must}
                            allCompanyScore={industryMedian.must}
                            industryNPS={industryNPS.must}
                            percentageNPS={true}
                        />
                    </div>
                    <div className="flex-item">
                        <ScoreIndicator
                            label="Does Maintain an Advantage"
                            companyScore={company.does}
                            allCompanyScore={industryMedian.does}
                            industryNPS={industryNPS.does}
                            hasBorder={true}
                            negativeNPS={true}
                        />
                    </div>
                    <div className="flex-item">
                        <ScoreIndicator
                            label="Is Demonstrating Commitment"
                            companyScore={company.commitment}
                            allCompanyScore={industryMedian.commitment}
                            industryNPS={industryNPS.commitment}
                            negativeNPS={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Scores;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/Scores.tsx